module.exports = __webpack_public_path__ + "img/star.c8fbf166.svg";